import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userLogin } from '../../redux/modules/auth';
import { apiUrl } from '../../utils/consts';
import { businessName } from '../../utils/consts';
import { setInStorage } from '../../utils/storage';
import './styles/Login.scss';

function mapDispatchToProps(dispatch) {
  return {
    userLogin: payload => dispatch(userLogin(payload))
  };
}

function ConnectedLoginComponent(props) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) setError('');
  }, [loading]);

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setLoading(true);

      const loginProm = await fetch(`${apiUrl}/users/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          password,
          businessName
        })
      });

      const loginResp = await loginProm.json();

      if (loginResp.success) {
        props.userLogin({ user: loginResp.user, userId: loginResp.userId, token: loginResp.token });
        setInStorage('nibi_business_app', { token: loginResp.token });
      } else {
        setError('Usuario incorrecto.');
        setLoading(false);
      }

    }
  };

  return (
    <div className="login-component">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row>
          <Col xs={12}>
            <div className="app-title">
              Bienvenido
            </div>
          </Col>
          <Form.Group as={Col} xs={12}>
            <Form.Label className="app-label">Correo</Form.Label>
            <Form.Control
              type="text"
              placeholder="Correo"
              value={email}
              onChange={event => setEmail(event.target.value)}
              required
            />
          </Form.Group>
          <Form.Group as={Col} xs={12}>
            <Form.Label className="app-label">Contraseña</Form.Label>
            <Form.Control
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={event => setPassword(event.target.value)}
              required
            />
          </Form.Group>
          <Col xs={12}>
            <div>
              <span className="app-link" onClick={() => props.history.push('/recuperar_contrasenia')}>
                Olvidé mi contraseña
              </span>
            </div>
            <div>
              <span className="app-link" onClick={() => props.history.push('/crear_cuenta')}>
                Crear cuenta
              </span>
            </div>
          </Col>
        </Form.Row>
        <Button type="submit" className="app-button" disabled={loading}>
          {
            loading ? <Spinner animation="border" variant="warning" size="sm" /> : 'Iniciar sesión'
          }
        </Button>
        {
          error &&
          <>
            <br />
            <Alert variant="danger">
              { error }
            </Alert>
          </>
        }
      </Form>
    </div>
  );
}

const LoginComponent = connect(null, mapDispatchToProps)(ConnectedLoginComponent);

export default withRouter(LoginComponent);
